/**
 * @desc 接口导出
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<Array<defs.appCenter.ApiInfoAggregateDto>>;
export function request(
  body: defs.appCenter.ApiExportRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/api/export`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
